import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const listManufacturers = unaryRpc({
  name: "listManufacturers" as const,
  input: z.object({}),
  output: z.object({
    manufacturers: z.array(z.object({ id: z.string(), name: z.string() })),
  }),
});
